import React from 'react';
import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    Button,
    useTheme
} from '@mui/material';

const OTPVerification = ({
    formData,
    errors,
    timer,
    otpSent,
    isLoading,
    canResendOTP,
    onChange,
    onSendOTP,
    size = 'medium'
}) => {
    const theme = useTheme();

    return (
        <Box>
            <Typography variant="subtitle2" sx={{
                mb: 1,
                color: theme.palette.text.secondary,
                fontWeight: 600
            }}>
                Verification
            </Typography>
            <TextField
                size={size}
                fullWidth
                label="OTP"
                name="otp"
                value={formData.otp}
                onChange={onChange}
                error={Boolean(errors.otp)}
                helperText={errors.otp}
                placeholder="Enter OTP"
                InputProps={{
                    sx: { borderRadius: 2 },
                    endAdornment: (
                        <InputAdornment position="end">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {timer > 0 && otpSent && (
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            minWidth: 45
                                        }}
                                    >
                                        {`${timer}s`}
                                    </Typography>
                                )}
                                <Button
                                    size="small"
                                    onClick={onSendOTP}
                                    disabled={isLoading || (otpSent && !canResendOTP)}
                                    sx={{
                                        textTransform: 'none',
                                        fontSize: '0.8rem',
                                        fontWeight: 600,
                                        minWidth: 85,
                                        ...(timer > 0 && otpSent && {
                                            opacity: 0.7,
                                            cursor: 'not-allowed'
                                        })
                                    }}
                                >
                                    {isLoading ? 'Sending...' : (otpSent ? 'Resend OTP' : 'Get OTP')}
                                </Button>
                            </Box>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

export default OTPVerification;
